export const getFromAndToParam = (date?: Date) => {
    if (!date) return { from: null, to: null };
    const dayStart = new Date(date?.getTime() || 0).setHours(0, 0, 0, 0);
    const dayEnd = new Date(date?.getTime() || 0).setHours(24, 0, 0, 0);
    return {
        from: dayStart / 1000 || null,
        to: dayEnd / 1000 || null,
    };
};
